import { v4 as uuidv4 } from 'uuid';
import { authEnvironment, safeGet, safeSet, type AuthEnvironment } from './environment';
import type { AuthNamespace } from './namespace';

export interface DeviceIdOptions {
    namespace: Pick<AuthNamespace, 'deviceIdKey'>;
    env?: Partial<Pick<AuthEnvironment, 'storage'>>;
}

export interface DeviceIdStore {
    /** Стабильный id устройства: создаётся при первом вызове и хранится в localStorage. */
    get(): string;
}

/**
 * Корреляционный (не секретный) id устройства для политики нескольких устройств на сервере. При выходе не чистится.
 * Без хранилища id живёт в памяти экземпляра.
 */
export function createDeviceId({ namespace, env }: DeviceIdOptions): DeviceIdStore {
    const { deviceIdKey } = namespace;
    const resolved = authEnvironment(env);
    // только когда хранилище не записывает: тогда id стабилен хотя бы на время жизни экземпляра
    let memoryId: string | null = null;

    const persist = (id: string) => {
        safeSet(resolved.storage, deviceIdKey, id);
        memoryId = safeGet(resolved.storage, deviceIdKey) === id ? null : id;
        return id;
    };

    // uuid v4, а не `crypto.randomUUID`: на интранет-стендах по http его нет.
    return { get: () => safeGet(resolved.storage, deviceIdKey) ?? memoryId ?? persist(uuidv4()) };
}
